import Dashboard from "pages/Dashboard/Dashboard"
import Login from "pages/Login"
import User from "pages/User/User"
import UserForm from "pages/User/UserForm"
import Location from "pages/Location/Location"
import LocationForm from "pages/Location/LocationForm"
import Employee from "pages/Employee/Employee"
import EmployeeForm from "pages/Employee/EmployeeForm"
import Setting from "pages/Setting/Setting"
import Sales from "pages/Sales/Sales"
import VehicleBrand from "pages/Setting/VehicleBrand/VehicleBrand"
import VehicleBrandForm from "pages/Setting/VehicleBrand/VehicleBrandForm"
import VehicleColor from "pages/Setting/VehicleColor/VehicleColor"
import VehicleColorForm from "pages/Setting/VehicleColor/VehicleColorForm"
import EmployeeAccess from "pages/EmployeeAccess/EmployeeAccess"
import Session from "pages/Session/Session"
import SalesForm from "pages/Sales/SalesForm"
import Report from "pages/Report/Report"
import MonthlyReport from "pages/Report/DailyReport/DailyReport"
import DailyReport from "pages/Report/DailyReport/DailyReport"

export const routes = [
   {
      path: "/login",
      element: <Login />
   },
   {
      path: "/",
      element: <Dashboard />
   },
   {
      path: "/location",
      element: <Location />
   },
   {
      path: "/location/form",
      element: <LocationForm />
   },
   {
      path: "/user",
      element: <User />
   },
   {
      path: "/user/form",
      element: <UserForm />
   },
   {
      path: "/employee",
      element: <Employee />
   },
   {
      path: "/employee/form",
      element: <EmployeeForm />
   },
   {
      path: "/employee-access",
      element: <EmployeeAccess />
   },
   {
      path: "/setting",
      element: <Setting />
   },
   {
      path: "/setting/vehicle-brand",
      element: <VehicleBrand />
   },
   {
      path: "/setting/vehicle-brand/form",
      element: <VehicleBrandForm />
   },
   {
      path: "/setting/vehicle-color",
      element: <VehicleColor />
   },
   {
      path: "/setting/vehicle-color/form",
      element: <VehicleColorForm />
   },


   {
      path: "/sales",
      element: <Sales />
   },
   {
      path: "/sales/form",
      element: <SalesForm />
   },
   {
      path: "/report",
      element: <Report />
   },
   {
      path: "/report/daily-report",
      element: <DailyReport />
   },
   {
      path: "/session",
      element: <Session />
   },
]

export const ROLE_ADMIN = "admin"
export const ROLE_OWNER = "owner"